import abc_premium_bordereaux from "./templates/abc_premium_bordereaux.js"
import abc_risk_london from "./templates/abc_risk_london.js"
import abc_risk from "./templates/abc_risk.js"
import abc_debit_note from "./templates/abc_debit_note.js"
import abc_policy_renewal from "./templates/abc_policy_renewal.js"
import abc_claim from "./templates/abc_claim.js"
import abc_claim_bordereaux from "./templates/abc_claim_bordereaux.js"
import abc_claims_paid from "./templates/abc_claims_paid.js"
import abc_claims_outstanding from "./templates/abc_claims_outstanding.js"

export default {
	abc_premium_bordereaux,
	abc_risk_london,
	abc_risk,
	abc_debit_note,
	abc_policy_renewal,
	abc_claim,
	abc_claim_bordereaux,
	abc_claims_paid,
	abc_claims_outstanding
}
